import PathFragmentDto from "./PathFragmentDto";

export default class ApiFragmentDto {

    ApiFragmentId: number;
    Fragment: string;
    SwaggerVisible: boolean;
    PathFragments: PathFragmentDto[];
    Url: string;
    CustomerApiCredentialIds: number[];

    constructor(apiFragmentId: number, fragment: string, swaggerVisible: boolean, pathFragments: PathFragmentDto[], url: string, customerApiCredentialIds: number[]) {
        this.ApiFragmentId = apiFragmentId;
        this.Fragment = fragment;
        this.SwaggerVisible = swaggerVisible;
        this.PathFragments = pathFragments;
        this.Url = url;
        this.CustomerApiCredentialIds = customerApiCredentialIds;
    }
}
